import React from 'react';
import tw from 'twin.macro';
import { Checkbox } from 'components/Form/Checkboxes/Checkbox';

interface Props {
  isSelected: boolean;
  onSelect: () => void;
}

export function DiffCheckbox(props: Props) {
  const { isSelected, onSelect } = props;
  return (
    <>
      <div
        css={[
          tw`absolute inset-y-0 left-0 w-1`,
          isSelected && tw`bg-brand-intense`,
        ]}
      />
      <Checkbox onChange={onSelect} checked={isSelected} />
    </>
  );
}
